import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import TablePracticeState from './table';
import { PracticeDetailVM } from 'practice/view-models/practice-detail';

interface AccordionPracticeStateProps {
  disabled?: boolean;
}

const AccordionPracticeStateComponent = ({
  disabled = false,
}: AccordionPracticeStateProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<PracticeDetailVM>();

  // const onChange = useEventCallback(
  //   (key: keyof AccordionPracticeVM, value: AccordionPracticeVM[keyof AccordionPracticeVM]) => {
  //     formContext.setFieldValue('practice', {
  //       ...(formContext.values.practice || {}),
  //       [key]: value,
  //     });
  //   }
  // );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-practice-content"
        id="accordion-practice-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Stato avanzamento della pratica</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TablePracticeState
          disabled={disabled}
          data={formContext.values.practiceState?.body || []}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionPracticeStateComponent.displayName = 'Practice State - Table - accordion practice state';

const AccordionPracticeState = memo(AccordionPracticeStateComponent);

export default AccordionPracticeState;
